const SEC_IN_SEC = 1;
const SEC_IN_MIN = 60;
const MIN_IN_HOUR = 60;
const SEC_IN_HOUR = SEC_IN_MIN * MIN_IN_HOUR;

const HOURS_MULTIPLIERS = [SEC_IN_HOUR, SEC_IN_MIN, SEC_IN_SEC];
const COMPACT_MULTIPLIERS = [SEC_IN_MIN, SEC_IN_SEC];

export default function fastDuration(compactMode = false) {
  const multipliers = compactMode ? COMPACT_MULTIPLIERS : HOURS_MULTIPLIERS;

  return function _decoder(num: number) {
    if (typeof num !== 'number') {
      return '';
    }
    num = Math.floor(num);

    return multipliers.reduce((memo, multiplier) => {
      memo = memo ? `${memo}:` : '';
      memo += pad(Math.floor(num / multiplier));
      num = num % multiplier;
      return memo;
    }, '');
  };
}

function pad(num: number): string {
  return num > 9 ? `${num}` : `0${num}`;
}
